<template>
    <BorrarModalComponent
        :name="'borrar-' + localPrecio.id"
        title="¿Seguro que quieres borrar este tipo de abono?"
        borrarTitle="Datos del tipo de abono"
        confirmButton="¿BORRAR TIPO DE ABONO?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarPrecio()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Nombre:</b> {{ localPrecio.descripcion }}
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ['lista_id', 'precio'],
        data() {
            return {
                localPrecio: { ...this.precio }
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.localPrecio.id, borrado);
            },
            borrarPrecio() {
                this.localPrecio.filters = {};
                this.localPrecio.lista_id = this.lista_id;
                this.localPrecio.precio_id = this.precio.id;

                this.$store.dispatch(this.config.getVuexAlias('back.precios.borrar'), this.localPrecio).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error);
                    console.log(error);
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
